import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flower2, BookOpen, Briefcase, Building2, PartyPopper, Heart, ArrowRight } from "lucide-react";
import { cachedGet } from "@/lib/api";
import Reveal from "@/components/Reveal";
import { SectionTitle } from "@/components/EventsGrid";

const EVENT_TYPES = [
  { icon: Flower2, label: "Mata Ki Chowki" },
  { icon: BookOpen, label: "Bhagwat Katha" },
  { icon: Briefcase, label: "Corporate Events" },
  { icon: Building2, label: "Society Events" },
  { icon: PartyPopper, label: "Festival Events" },
  { icon: Heart, label: "Weddings & Functions" },
];

const PALACE_IMG = "https://images.unsplash.com/photo-1636226942649-ee15d2a7ce04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxnbG93aW5nJTIwb2lsJTIwbGFtcCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4NjAwMDA3Mnww&ixlib=rb-4.1.0&q=70&w=900&auto=format";

export default function WatchAndPrivate() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    cachedGet("/videos").then(({ data }) => setVideos(data)).catch(() => {});
  }, []);

  return (
    <section id="watch" className="px-6 md:px-12 py-6 md:py-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Reveal>
          <div className="rounded-xl border border-bone/10 bg-surface/60 p-7 h-full" data-testid="watch-panel">
            <SectionTitle testid="watch-heading">WATCH OUR PERFORMANCES</SectionTitle>
            {videos.length === 0 ? (
              <a href="https://www.instagram.com/thebandsumiran/" target="_blank" rel="noreferrer"
                className="mt-8 block border border-bone/10 rounded-lg p-8 text-center hover:border-saffron transition-colors"
                data-testid="watch-empty-link">
                <p className="font-serif text-xl text-bone">Performances streaming soon</p>
                <p className="text-xs text-ash mt-2">Follow @thebandsumiran on Instagram to catch every reel →</p>
              </a>
            ) : (
              <div className="mt-7 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {videos.slice(0, 4).map((v, i) => (
                  <div key={v.id} className="rounded-lg overflow-hidden border border-bone/10 bg-ink" data-testid={`watch-video-${i}`}>
                    <div className={v.orientation === "landscape" ? "aspect-video" : "aspect-[9/13] max-h-[240px]"}>
                      <iframe src={v.embed_url} className="ig-embed-frame" title={v.title} loading="lazy" scrolling="no" allowFullScreen />
                    </div>
                    <p className="px-2.5 py-2.5 text-[10px] text-bone/80 text-center truncate">{v.title}</p>
                  </div>
                ))}
              </div>
            )}
            <div className="mt-7 text-center">
              <a href="https://www.instagram.com/thebandsumiran/" target="_blank" rel="noreferrer"
                className="inline-flex items-center gap-2 px-7 py-3 border border-bone/25 text-bone text-[10px] font-bold tracking-[0.15em] rounded-full hover:border-saffron hover:text-saffron transition-colors"
                data-testid="watch-view-all-btn">
                VIEW ALL VIDEOS
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="relative rounded-xl border border-bone/10 overflow-hidden h-full min-h-[420px]" data-testid="private-events-panel">
            <img src={PALACE_IMG} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover opacity-25" />
            <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/40" />
            <div className="relative p-7">
              <h2 className="font-display text-xl sm:text-2xl tracking-[0.15em] text-bone" data-testid="private-events-heading">
                BOOK US FOR YOUR<br /><span className="text-gold">PRIVATE EVENTS</span>
              </h2>
              <div className="mt-8 grid grid-cols-3 gap-x-4 gap-y-7 max-w-md">
                {EVENT_TYPES.map((t) => (
                  <div key={t.label} className="text-center" data-testid={`event-type-${t.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                    <t.icon size={26} className="mx-auto text-gold" strokeWidth={1.4} />
                    <p className="mt-2.5 text-[10px] tracking-wide text-bone/80 leading-snug">{t.label}</p>
                  </div>
                ))}
              </div>
              <Link to="/bookprivateshow"
                className="mt-9 inline-flex items-center gap-2.5 px-8 py-3.5 bg-saffron text-ink text-xs font-bold tracking-[0.12em] rounded-full hover:bg-gold transition-colors"
                data-testid="private-enquire-btn">
                ENQUIRE NOW <ArrowRight size={15} />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
